import {
  React,
  Component,
  PropTypes
} from 'imports/CommonImports';

import {FlatButton} from 'material-ui';

const styles = {
  button: {
    width: '15em',
    border: '1px solid #1B2543',
  },
  label: {
    color: '#1B2543',
  },
}

class SecondaryButton extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return(
      <FlatButton
        disabled={this.props.disabled}
        labelStyle={styles.label}
        backgroundColor='#FFFFFF'
        label={this.props.label}
        onClick={this.props.onClick}
        style={this.props.style || styles.button}
        href={this.props.href}
        buttonStyle={styles.buttonStyle}
        />
    );
  }
}

SecondaryButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string
}

export default SecondaryButton;



// WEBPACK FOOTER //
// ./src/components/design/SecondaryButtonFlat.js